<template>
  <div>
    <b-button @click="openModal()">
      Update additional info
    </b-button>
    <b-modal
      :ref="refModal"
      @ok="updateValue()"
    >
      <label for="image">Image tree</label>
      <b-form-file
        id="image"
        v-model="imageTree"
        accept="image/*"
      />
      <b-button v-show="value.previous_imageTree" @click="openImagePrevious()">
        See previous image
      </b-button>
      <b-modal
        :ref="refModal + '-previous-image'"
        size="lg"
        ok-only
      >
        <img :src="value.previous_imageTree" class="previous_image" alt="previous-image" />
      </b-modal>
      <br />
      <label for="video">Video</label>
      <b-form-file
        id="video"
        v-model="video"
        accept="video/*"
      />
      <b-button v-show="value.previous_video" @click="openVideoPrevious()">
        See previous video
      </b-button>
      <b-modal
        :ref="refModal + '-previous-video'"
        size="lg"
        ok-only
      >
        <video
          controls
          preload="auto"
          class="previous_video"
          :src="value.previous_video"
        ></video>
      </b-modal>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  BFormFile
} from 'bootstrap-vue'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    BModal,
    BButton,
    BFormFile
  },
  data() {
    return {
      imageTree: null,
      video: null
    }
  },
  computed: {
    modalId() {
      return Math.floor(Math.random())
    },
    refModal() {
      return this.modalId + '-modal-additional-info'
    }
  },
  methods: {
    openModal() {
      this.$refs[this.refModal].show()
    },
    updateValue() {
      this.$emit('input', {
        ...this.value,
        imageTree: this.imageTree,
        video: this.video
      })
    },
    openImagePrevious() {
      this.$refs[this.refModal + '-previous-image'].show()
    },
    openVideoPrevious() {
      this.$refs[this.refModal + '-previous-video'].show()
    }
  }
}
</script>

<style lang="scss" scoped>
.previous_image {
  margin: 0 auto;
  max-width: 100%;
  height: auto;
}
.previous_video {
  max-width: 100%;
  height: auto;
}
</style>